import {
    RINKEBY_CHAIN_ID,
    GOERLI_CHAIN_ID,
    PALM_TEST_CHAIN_ID,
    MAIN_NET_ID,
    PALM_CHAIN_ID,
    BINANCE_TESTNET_CHAIN_ID,
    BINANCE_CHAIN_ID,
} from "@liveart/nft-client/dist/chainId";

export const getAllBlockChainNameByChainId = (networkId: number) => {
    switch (networkId) {
        case BINANCE_TESTNET_CHAIN_ID:
            return "Binance Testnet";
        case BINANCE_CHAIN_ID:
            return "Binance Smart Chain";
        case GOERLI_CHAIN_ID:
            return "Goerli";
        case RINKEBY_CHAIN_ID:
            return "Rinkeby";
        case MAIN_NET_ID:
            return "Ethereum";
        case PALM_CHAIN_ID:
            return "Palm";
        case PALM_TEST_CHAIN_ID:
            return "Palm Testnet";
        default:
            return "";
    }
};
